import { BoardColumnType, BoardConfigurationType, SurveyConfigurationType, SurveyRespondentIdentifyBy } from "@/common/interfaces";
import moment from "moment";
import { Moment } from "moment";

export declare type StoredBoardLoadedState = 'info' | 'columns' | 'configuration' | 'participants';

export class Column {
	readonly uuid: string;
	name: string;
	index: number;
	emoji: string | null;
	participantsCanAddCards: boolean;

	constructor(column: BoardColumnType) {
		this.uuid = column.uuid;
		this.name = column.name;
		this.index = column.index;
		this.emoji = column.emoji;
		this.participantsCanAddCards = column.participantsCanAddCards;
	}
}

export class Configuration {
	identifyBy: SurveyRespondentIdentifyBy = SurveyRespondentIdentifyBy.IP_ADDRESS;
	allowMultipleResponses: boolean = false;
	closeDate: Date | null = null;

	constructor(configuration: SurveyConfigurationType) {
		this.fromConfigurationType(configuration);
	}

	fromConfigurationType(configuration: SurveyConfigurationType) {
		this.identifyBy = configuration.identifyBy;
		this.allowMultipleResponses = configuration.allowMultipleResponses;

		if (configuration.closeDate !== null) {
			this.closeDate = new Date(
				Date.parse(configuration.closeDate)
			);
		}
	}

	update(configuration: SurveyConfigurationType) {
		this.fromConfigurationType(configuration);
	}
}
